import * as yup from 'yup'
import { Form, RadioGroupItem, Text } from '@/ui'
import { TypographyStyles } from '@/styles'

export const QuestionRow = ({
  label,
  name,
  tooltip,
  schema,
}: {
  label: string
  name: string
  tooltip: React.ReactNode
  schema?: yup.StringSchema<string | null | undefined>
}) => (
  <>
    <Text
      variant={TypographyStyles.DISPLAY_XXS}
      className="mt-4 flex items-center gap-1"
    >
      {label}
      {tooltip}
    </Text>
    <Form.RadioGroup
      className="min-h-fit flex gap-4"
      name={name}
      schema={
        schema
          ? schema
          : yup.string().nullable().oneOf(['true', 'false']).required()
      }
    >
      <RadioGroupItem value="true" id={`${name}-yes`} label="Yes" />
      <RadioGroupItem value="false" id={`${name}-no`} label="No" />
    </Form.RadioGroup>
  </>
)
